<template>
  <div class="radio-item__wrapper">
    <div
      class="radio-item"
      v-for="item in list"
      :key="item.id"
    >
      <template v-if="item.children">
        <div class="radio-item__heading">{{ item.title }}</div>
        <div class="radio-item__list">
          <RadioListItem :list="item.children" :selected="selected" @change="change" :mobile="mobile" />
        </div>
      </template>
      <template v-else>
        <div
          class="radio-item__child"
          :class="{
            'is--active': item.id === selected,
            'is--mobile': mobile,
            'is--default-mobile': !mobile
          }"
          @click="change(item.id)"
        >
          <span class="is--dot" />
          <span class="is--text" :title="item.title">{{ item.title }}</span>
          <span class="is--tag" :title="item.tag">{{ item.tag }}</span>
          <span class="is--check" v-if="mobile">
            <i class="ri-check-fill"></i>
          </span>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RadioListItem',
  props: ['list', 'selected', 'mobile'],
  methods: {
    change(id) {
      this.$emit('change', id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .radio-item {
    &__wrapper {
      width: 100%;
      .radio-item__wrapper {
        padding-left: 20px;
      }
    }
    &__heading {
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      font-feature-settings: 'zero' on;
      margin-bottom: 16px;
    }
    &__child {
      font-weight: 300;
      font-size: 16px;
      line-height: 150%;
      font-feature-settings: 'ss02' on;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      cursor: pointer;
      span {
        &.is--text,
        &.is--tag {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        &.is--dot {
          display: flex;
          width: 20px;
          height: 20px;
          min-width: 20px;
          min-height: 20px;
          background: var(--label-tetriary);
          position: relative;
          border-radius: 100%;
          align-items: center;
          justify-content: center;
          margin-right: 4px;
          &::before {
            content: '';
            width: 5px;
            height: 5px;
            background: var(--label-tetriary);
            border-radius: 100%;
            display: block;
          }
        }
        &.is--check {
          font-size: 24px;
          font-weight: normal;
          color: var(--accent-blue);
          margin-left: 4px;
          opacity: 0;
        }
      }
      &.is--active {
        span {
          &.is--dot {
            background: var(--accent-blue);
            &::before {
              width: 10px;
              height: 10px;
              background: var(--light-01);
            }
          }
        }
      }
    }
  }

  @media (max-width: 425px) {
    .radio-item {
      &__heading {
        margin: 0;
      }
      &__child {
        height: 48px;
        margin-bottom: 0;
        &.is--active {
          font-weight: 500;
          span.is--check {
            opacity: 1;
          }
        }
        span {
          font-weight: normal;
        }
        &.is--mobile {
          span.is--tag {
            margin-left: auto;
          }
        }
        &.is--default-mobile {
          height: 24px;
          margin: 16px 0;
        }
      }
    }
  }
</style>
